import React from 'react'

const H3 = (props) => <h3 {...props} />

export default H3
